var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "#222222",
    fillOpacity: 0.02
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 42C48.4183 42 52 38.4183 52 34C52 29.5817 48.4183 26 44 26C39.5817 26 36 29.5817 36 34C36 38.4183 39.5817 42 44 42Z",
    fill: "var(--primary-color, #222222)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 62C51.732 62 58 58.4183 58 54C58 49.5817 51.732 46 44 46C36.268 46 30 49.5817 30 54C30 58.4183 36.268 62 44 62Z",
    fill: "var(--primary-color, #222222)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.91386597625089fb068f5ff924c8f543.svg";
export { ForwardRef as ReactComponent };